import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {MenuItem} from "primeng/api";
import {PersonAddressDto} from "../../../model/dto/entity/person-address.dto";
import {PersonContactDto} from "../../../model/dto/entity/person-contact.dto";
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectRequestComplex} from "../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../core/shared/dto/object/request/object-request-relation";
import {WidgetToolbarCallbackInterface} from "../../../../../core/shared/widget/widget-toolbar-callback.interface";
import {MvsFormControlOverwrite} from "../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite";
import {MvsFormFieldAccessEnum} from "../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum";
import {EntityStatusEnum} from "../../../../../core/shared/entity/enum/entity-status.enum";
import {PersonDto} from "../../../model/dto/entity/person.dto";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../core/shared/helper/widget-function-call-back-create";


@Component({
    selector: 'pm-person',
    templateUrl: './pm-person.component.html',
    standalone: false
})
export class PmPersonComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    tabItems: MenuItem[];
    activeItem: MenuItem | undefined;
    tabIndex: string = "pm.Person";
    widgetPerson: WidgetData;
    widgetPersonAddress: WidgetData;
    widgetPersonContact: WidgetData;
    widgetPersonAddressList: WidgetData;
    widgetPersonContactList: WidgetData;
    contextPerson: DtoImportObjectContext;

    dto: PersonDto;

    ngOnInit() {
        super.ngOnInit();

        this.tabItems = [
            { id : "pm.Person", label : "Person", icon : 'fa-light fa-person'},
            { id : "pm.PersonAddress", label : "Adresse", icon : 'fa-light fa-location-dot'},
            { id : "pm.PersonContact", label : "Kontaktdaten", icon : 'fa-light fa-address-book'},
        ];
        this.activeItem = this.tabItems[0];

    }

    onActiveItemChange(event: string | number) {
        this.activeItem = this.tabItems.find(item => item.id == event);
        this.tabIndex = this.activeItem.id;
    }

    /**
     * On Object Change.
     */
    onObjectChanged() {

        this.widgetPerson = WidgetFactory.createWidgetObject(
            "pm.person.object.form",
            "Person",
            "pm.Person",
            this.dto.id
        );

        // create person context
        this.contextPerson = DtoImportObjectContext.createFromObjectIdentifier(this.objectIdentifier)

        // create filter
        const filterPerson = FilterCriteria.create("person", FilterCriteria.cOperatorEqual, this.dto.id);

        // Capture person ID for use in callbacks
        const personId = this.dto.id;

        // create widget for Address
        this.widgetPersonAddress = WidgetFactory.createWidgetListWithDetailEntityAndCallback(
            "pm.person.object.address.form",
            "Adressen",
            "pm.PersonAddress",
            "Keine Addressdaten vorhanden",
            ObjectRequestList.createComplexRequestList(
                true,
                ObjectRequestComplex.build(true, false, ObjectRequestComplexNode.createRelationNode("address", ObjectRequestRelation.createJoin("address"))),
                [filterPerson],
                [],
                null),

            {
                onFunctionObjectUpdate(widgetData: WidgetData): WidgetToolbarCallbackInterface {
                    const overwrite = new MvsFormControlOverwrite();
                    overwrite.addField("personDtoId",MvsFormFieldAccessEnum.HIDDEN);
                    return { formControlOverwrite: overwrite };
                },
                onFunctionObjectDefaultNew(widgetData: WidgetData): WidgetToolbarCallbackInterface {
                    const overwrite = new MvsFormControlOverwrite();
                    overwrite.addField("personDtoId",MvsFormFieldAccessEnum.HIDDEN);

                    const personAddressDto = new PersonAddressDto();
                    personAddressDto.personDtoId = personId;  // Set the person ID
                    personAddressDto.startDate = new Date();
                    personAddressDto.entityStatus = EntityStatusEnum.active;

                    return { formControlOverwrite: overwrite, dto: personAddressDto };
                }
            }
        );

        // create widget for Contact
        this.widgetPersonContact = WidgetFactory.createWidgetListWithDetailEntityAndCallback(
            "pm.person.object.contact.form",
            "Kontaktdaten",
            "pm.PersonContact",
            "Keine Kontaktdaten vorhanden",
            ObjectRequestList.createComplexRequestList(
                true,
                ObjectRequestComplex.build(true, false, ObjectRequestComplexNode.createRelationNode("contact", ObjectRequestRelation.createJoin("contact"))),
                [filterPerson],
                [],
                null),

            {
                onFunctionObjectUpdate(widgetData: WidgetData): WidgetToolbarCallbackInterface {
                    const overwrite = new MvsFormControlOverwrite();
                    overwrite.addField("personDtoId",MvsFormFieldAccessEnum.HIDDEN);
                    return { formControlOverwrite: overwrite };
                },
                onFunctionObjectDefaultNew(widgetData: WidgetData): WidgetToolbarCallbackInterface {
                    const overwrite = new MvsFormControlOverwrite();
                    overwrite.addField("personDtoId",MvsFormFieldAccessEnum.HIDDEN);

                    const personContactDto = new PersonContactDto();
                    personContactDto.personDtoId = personId;  // Set the person ID
                    personContactDto.startDate = new Date();
                    personContactDto.entityStatus = EntityStatusEnum.active;

                    return { formControlOverwrite: overwrite, dto: personContactDto };
                }
            }
        );
        //Ticket Number : 1000001288
        this.widgetPersonAddressList = WidgetFactory.createWidgetList(
            "pm.PersonAddress.List.cr.customer.page",
            "Adressen",
            "table",
            "list",
            "entity",
            "pm.PersonAddress",
            "Keine Addressdaten vorhanden",
            ObjectRequestList.createBasic(true, [filterPerson],null)
        );
        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'personDtoId', fieldValue: this.dto.id}]

        this.widgetPersonAddressList.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

        this.widgetPersonContactList = WidgetFactory.createWidgetList(
            "pm.PersonContact.List.cr.customer.page",
            "Kontaktdaten",
            "table",
            "list",
            "entity",
            "pm.PersonContact",
            "Keine Kontaktdaten vorhanden",
            ObjectRequestList.createBasic(true, [filterPerson],null)
        );

        this.widgetPersonContactList.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

}
